<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد دسته بندی تجربه
        </b-button>
      </b-col>
    </b-row>
    <div v-if="categories">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>تصویر</b-th>
            <b-th>عنوان</b-th>
            <b-th>فرزند</b-th>
            <b-th>نمایش در ص</b-th>
            <b-th>تاریخ</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="category in categories" :key="category.id">
            <b-th>
              <img
                  v-if="category.image"
                  style="border-radius: 15px; width: 35px"
                  :src="$http.defaults.fileUrl+'/' + category.image"
              /></b-th>
            <b-td>{{ category.name }}</b-td>
            <b-td>
              <b-badge variant="primary" v-if="category.parent">
                  {{category.parent.name}}
              </b-badge>
              <span v-else>
                  -----------
                </span>
            </b-td>
            <b-td >
              <span v-if="category.breaking_news" style="color: green">
                  فعال
              </span>
                <span v-else>
                  غیر فعال
                </span>
            </b-td>
            <b-td>
              {{
                new Date(category.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col class="d-flex align-items-center">
<!--                <b-button
                    @click="showConfirmModal(category)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                    @click="showFormModal(category)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="850px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش دسته بندی" : "ایجاد دسته بندی" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.name" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> اسلاگ | slug : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="categoryInput.slug" type="text" />
          <ErrorMessage
              errorType="slug"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="col-md-12">
          <label for="parent_id" class="text-capitalize">انتخاب والد :</label>
          <select
              id="parent_id"
              v-model="categoryInput.parent_id"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </b-form-group>

        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر ایکون:
          </label>
          <FilePicker
              @inputFile="inputIconImageFile"
              :url="iconImageurl"
              ref="iconImageFilePicker"
          ></FilePicker>
          <ErrorMessage
              errorType="image"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> alt image   : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.alt_image" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان سئو (title)   : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.meta_title" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> کلمات کلیدی keywords : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="categoryInput.meta_keyword" type="text" />
          <ErrorMessage
              errorType="slug"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>


        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> توضیحات سئو meta Description : </label>
          <b-form-textarea
              id="description"
              v-model="categoryInput.meta_description"
              type="text"
              @input="removeErrors('meta_description')"
          />
          <ErrorMessage
              errorType="description"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>

        <b-form-group class="col-md-6">
          <label for="parent_id" class="text-capitalize">انتخاب دسته بندی  برای نمایش در صفحه اصلی :</label>
          <select
              id="parent_id"
              v-model="categoryInput.breaking_news"
              class="form-control"
          >
            <option value="" disabled>انتخاب کنید</option>
            <option value="1">
              فعال
            </option>
            <option value="0">
              غیرفعال
            </option>
          </select>
        </b-form-group>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd, BIconCalendar, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";

export default {
  components: {
    BBadge,
    BIconCalendar,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {

      optionsShow:[
        { value: null, text: 'انتخاب نمایش در ص اصلی' },
        { value: '0', text: 'عدم نمایش در صفحه اصلی' },
        { value: '1', text: 'نمایش در صفحه اصلی' },
      ],

      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      categories: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,


      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      categoryInput: {
        id: "",
        name: "",
        slug:"",
        image: "",
        menu_publish:"",
        parent_id: null,
        alt_image: null,
        meta_title: null,
        meta_keyword: null,
        meta_description: null,
        breaking_news: null,
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCategories();
    this.getBuildings();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCategories();
    },
    perPage(value) {
      this.page = 1;
      this.getCategories();
    },
    page(value) {
      this.getCategories();
    },
  },
  methods: {
    inputIconImageFile(file) {
      this.removeErrors("image");
      if (file) {
        this.categoryInput.image = file;
      }
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCategories();
    },

    async getCategories() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/newscategories",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.categories = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(category) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف دسته بندی مطمئن هستید ؟  : ${category.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.categories = await this.categories.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == category.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== category.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/newscategories/${category.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `دسته بندی: ${category.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.categories.splice(residenceIndex, 0, category);
                  });
            }
          });
    },
    showFormModal(category) {
      if (category) {
        this.categoryInput = {
          id: category.id,
          name: category.name,
          slug:category.slug,
          image: category.image,
          parent_id: category.parent_id,
          alt_image: category.alt_image,
          meta_title: category.meta_title,
          meta_keyword: category.meta_keyword,
          meta_description: category.meta_description,
          breaking_news: category.breaking_news,
        };
        //this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl = category.image
            ?  '/' + category.image
            : null;
        this.editMode = true;
      } else {
        this.categoryInput = {
          id: "",
          name: "",
          slug:"",
          image: "",
          menu_publish:"",
          parent_id: null,
          alt_image: null,
          meta_title: null,
          meta_keyword: null,
          meta_description: null,
          breaking_news: null,
        };
       // this.$refs.iconImageFilePicker.clearFileInput()
       // this.iconImageurl=""
        this.iconImageurl = null;
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!this.categoryInput.name) {
        this.errorMessage = { name: "لطفا نام دسته بندی را وارد کنید" };
      }
      if (!this.errorMessage && !this.categoryInput.slug) {
        this.errorMessage = { slug: "لطفا اسلاگ دسته بندی را وارد کنید" };
      }

      let formData = new FormData();

      formData.append("name", this.categoryInput.name);
      formData.append("slug", this.categoryInput.slug);

      if (this.categoryInput.parent_id) {
        formData.append("parent_id", this.categoryInput.parent_id);
      }
      if (this.categoryInput.image && this.categoryInput.image instanceof File) {
        formData.append("image", this.categoryInput.image);
      }
      if (this.categoryInput.alt_image) {
        formData.append("alt_image", this.categoryInput.alt_image);
      }
      if (this.categoryInput.meta_title) {
        formData.append("meta_title", this.categoryInput.meta_title);
      }
      if (this.categoryInput.meta_keyword) {
        formData.append("meta_keyword", this.categoryInput.meta_keyword);
      }
      if (this.categoryInput.meta_description) {
        formData.append("meta_description", this.categoryInput.meta_description);
      }
      if (this.categoryInput.breaking_news) {
        formData.append("breaking_news", this.categoryInput.breaking_news);
      }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/newscategories/update/${this.categoryInput.id}`
            : `/admin/newscategories`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      this.$http(requestData)
          .then((response) => {
            let message = "دسته بندی با موفقیت اضافه شد";
            if (this.editMode) message = "دسته بندی با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.residencesPaginationComponent.clear();
              // this.$refs.residencesSearchComponent.clear();
              this.$refs.residencesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getCategories();
          })
          .catch((err) => {
            let message = "خطا در ایجاد دسته بندی";
            if (this.editMode) message = "خطا در ویرایش دسته بندی";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
